module.exports = __webpack_public_path__ + "static/media/b-sci-major-8_LR.5e809640.jpg";